import { Box, type BoxProps } from "@chakra-ui/react";
import ReactMarkdown, { type Components } from "react-markdown";

import { Markdown } from "@equidefi/shared";

const components = {
  blockquote(props) {
    const { children, className } = props;

    return (
      <Box
        as="blockquote"
        pl={3}
        color="gray.500"
        borderLeft="2px solid"
        borderColor="gray.200"
        className={className}>
        {children}
      </Box>
    );
  },
} satisfies Components;

export const EquidefiMarkdown: React.FC<
  BoxProps & { children: string | null | undefined }
> = ({ children }) => {
  return (
    <Box __css={{ "& p:last-of-type": { mb: 0 } }}>
      <ReactMarkdown
        allowedElements={Markdown.AllowedElements}
        components={components}>
        {children}
      </ReactMarkdown>
    </Box>
  );
};
